import { GeoService } from "./GeoService";
import { ServiceCache } from "./ServiceCache";

let geoServiceInstance: GeoService;
let serviceCacheInstance: ServiceCache;

export const registerGeoService = (geoService: GeoService) => {
	if (geoServiceInstance) {
		console.error(`GeoService is already registered. Skipping.`);
		return;
	}
	geoServiceInstance = geoService;
};

export const getGeoService = (): GeoService => {
	if (!geoServiceInstance) {
		const msg = "geoServiceInstance not initialized yet";
		console.error(msg);
		return;
	}
	return geoServiceInstance;
};

export const registerServiceCache = (serviceCache: ServiceCache) => {
	if (serviceCacheInstance) {
		console.error(`serviceCacheInstance is already registered. Skipping.`);
		return;
	}
	serviceCacheInstance = serviceCache;
	if (process.env.NODE_ENV === "development") {
		(self || global).serviceCache = serviceCacheInstance;
	}
};

export const getServiceCache = (): ServiceCache => {
	if (!serviceCacheInstance) {
		const msg = "serviceCacheInstance not initialized yet";
		console.error(msg);
		return;
	}
	return serviceCacheInstance;
};
